import type {
  InvoiceColumnsType,
  InvoicingTypes,
} from "@/redux/invoicing/invoicingTypes";

export const initialState: InvoicingTypes = {
  fetching: false,
  error: null,
  message: null,
  success: null,
  columnList: {} as InvoiceColumnsType,
  individualColumnList: {} as InvoiceColumnsType,
  statusCode: null,
  revenueInvoiceList: [],
  expensesInvoiceList: [],
  viewInvoiceData: [],
  otherEntriesList: [],
  bulkUploadData: {},
  missingExpensesAttachmentCount: null,
  missingRevenueAttachmentCount: null,
  missingOthersAttachmentCount: null,
};
